// tslint:disable:max-line-length

import React from 'react';

export const ChartHorizontalBar = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <rect x="2" y="6" width="12" height="4" />
      <rect x="2" width="14" height="4" />
      <rect width="1" height="16" />
      <rect x="2" y="12" width="8" height="4" />
    </svg>
  );
};
